import React, { useState } from "react";
import { Row, Col, Typography, Button, Modal, Form, Input, message } from "antd";
import axiosInstance from "../../../interceptor/interceptor"; 

const {  Text } = Typography;

const ViewEmployeeDetails = ({ employee }) => {
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal state
  const [form] = Form.useForm(); // Ant Design Form instance
  const user = JSON.parse(localStorage.getItem("user"));
  if (!employee) {
    return <Text>No Employee Data Available</Text>;
  }

  // Open Modal
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  // Close Modal
  const handleCloseModal = () => {
    form.resetFields(); // Reset form fields on close
    setIsModalOpen(false);
  };

  // Handle Form Submission
  const handleFormSubmit = async (values) => {
    try {
      const response = await axiosInstance.post("auth/reset-password", {
        empno: employee.empno,
        newPassword: values.newPassword,
      });

      if (response.status === 200) {
        message.success("Password reset successfully!");
        handleCloseModal();
      }
    } catch (error) {
      ////console.error("Error resetting password:", error);
      message.error(
        error.response?.data?.message || "Failed to reset password. Please try again."
      );
    }
  };

  return (
    <div className="employee-view-container">
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Text strong>Employee Name:</Text>
          <Text style={{ marginLeft: 8 }}>{employee.firstname || "-"}</Text>
        </Col>
        <Col span={12}>
          <Text strong>Middle Name:</Text>
          <Text style={{ marginLeft: 8 }}>{employee.middlename || "-"}</Text>
        </Col>
        <Col span={12}>
          <Text strong>Last Name:</Text>
          <Text style={{ marginLeft: 8 }}>{employee.lastname || "-"}</Text>
        </Col>
        <Col span={12}>
          <Text strong>Site:</Text>
          <Text style={{ marginLeft: 8 }}>{employee.sitename || "-"}</Text>
        </Col>
        <Col span={12}>
          <Text strong>Phone:</Text>
          <Text style={{ marginLeft: 8 }}>{employee.phone || "-"}</Text>
        </Col>
        <Col span={12}>
          <Text strong>Email:</Text>
          <Text style={{ marginLeft: 8 }}>{employee.email || "-"}</Text>
        </Col>
        <Col span={12}>
          <Text strong>Province:</Text>
          <Text style={{ marginLeft: 8 }}>{employee.province || "-"}</Text>
        </Col>
        <Col span={12}>
          <Text strong>Employee Number:</Text>
          <Text style={{ marginLeft: 8 }}>{employee.empno || "-"}</Text>
        </Col>
        <Col span={12}>
          <Text strong>Employee Type:</Text>
          <Text style={{ marginLeft: 8 }}>{employee.emptype || "-"}</Text>
        </Col>
        <Col span={12}>
  <Text strong>Address:</Text>
  <Text style={{ marginLeft: 8 }}>{employee.address || "-"}</Text>
</Col>
      </Row>

      {/* Reset Password Button */}
      {
        user?.role === "SUPERADMIN" && (
          <div style={{ marginTop: 16 }}>
        <Button type="primary" onClick={handleOpenModal} 
                style={{ width: '200px', margin: '0 auto', display: 'block', lineHeight: '5px', }}
        >
          Reset Password
        </Button>
      </div>
        )
      }

      {/* Reset Password Modal */}
      <Modal
        title="Reset Password"
        open={isModalOpen}
        onCancel={handleCloseModal}
        footer={null}
      >
        <Form form={form} layout="vertical" onFinish={handleFormSubmit}>
          <Form.Item
            label="New Password"
            name="newPassword"
            rules={[
              { required: true, message: "Please enter the new password!" },
              { min: 6, message: "Password must be at least 6 characters long!" },
            ]}
          >
            <Input.Password placeholder="Enter new password" />
          </Form.Item>
          <Form.Item
            label="Confirm Password"
            name="confirmPassword"
            dependencies={["newPassword"]}
            rules={[
              { required: true, message: "Please confirm your password!" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Passwords do not match!"));
                },
              }),
            ]}
          >
            <Input.Password placeholder="Confirm new password" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit"
                    style={{ width: '200px', margin: '0 auto', display: 'block', lineHeight: '5px', }}
            >
           
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default ViewEmployeeDetails;
